import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { ScriptListState } from '../../../types/script';

//En este archivo se traen a los scripts cuyo user_id sea el mismo que el del usuario loggeado
//Esto sirve que el dashboard liste todos los scripts segun el usuario


const initialState: ScriptListState = {
    scripts: [],
    totalCount: 0,
    isLoading: false,
    error: null,
};

export const fetchScripts = createAsyncThunk(
    'scriptList/fetchScripts',
    async ({ userId, limit }: { userId: string; limit: number }, { rejectWithValue }) => {
        try {
            // Return empty mock data - no database available
            console.log('Fetched scripts (mock):', [], 'Total count:', 0);
            return { data: [], count: 0 }
        } catch (error: any) {
            console.error('Unexpected error in fetchScripts:', error);
            return rejectWithValue(error.message);
        }
    }
);




export const scriptListSlice = createSlice({
    name: 'scriptList',
    initialState,
    reducers: {
        clearScriptList: (state) => {
            state.scripts = [];
            state.totalCount = 0;
            state.isLoading = false;
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchScripts.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(fetchScripts.fulfilled, (state, action) => {
                state.isLoading = false;
                state.scripts = [...state.scripts, ...action.payload.data];
                state.totalCount = action.payload.count;
            })
            .addCase(fetchScripts.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload as string;
            });
    },
});

export const { clearScriptList } = scriptListSlice.actions;
export const scriptListReducer = scriptListSlice.reducer;
